export default class Access {
  constructor() {
    document.addEventListener("DOMContentLoaded", () => {
      this.init();
    });
  }

  init() {
    this.tabs = document.getElementsByClassName("js-access-tab");
    this.addClickEvents();
  }

  addClickEvents() {
    for (let i = 0; i < this.tabs.length; i++) {
      this.tabs[i].addEventListener("click", this.tabSwitch.bind(this));
    }
  }

  tabSwitch(event) {
    const clickedTab = event.currentTarget;

    // .l-access を起点として、ローカルなタブとパネルを制御
    const groupRoot = clickedTab.closest('.l-access');
    if (!groupRoot) return;

    const tabsInGroup = groupRoot.querySelectorAll('.js-access-tab');
    const panelsInGroup = groupRoot.querySelectorAll('.l-access__inner');

    // すべてのタブ・パネルから状態を削除
    tabsInGroup.forEach(tab => tab.classList.remove('is-active'));
    panelsInGroup.forEach(panel => panel.classList.remove('is-show'));

    // 押されたタブをアクティブに
    clickedTab.classList.add('is-active');

    // 対応するパネル（クラス名で判定）
    const targetClass = Array.from(clickedTab.classList).find(cls => cls.startsWith('is-tab-'));
    if (!targetClass) return;

    const targetPanel = groupRoot.querySelector(`.l-access__inner.${targetClass}`);
    if (targetPanel) {
      targetPanel.classList.add('is-show');
    }
  }
}
